import { render, staticRenderFns } from "./TaxonomySharingForm.vue?vue&type=template&id=6a15b62c&lang=pug"
import script from "./TaxonomySharingForm.vue?vue&type=script&lang=js"
export * from "./TaxonomySharingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports